import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../lib/api';
import AuthShell, {
  AuthHeader,
  AuthFooterLink,
  AuthSubmitButton,
  AuthError,
  AuthBackHome
} from '../components/auth/AuthShell';
import AuthField from '../components/auth/AuthField';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const data = await authAPI.forgotPassword(email.trim().toLowerCase());
      if (data.success) {
        setSent(true);
      } else {
        setError(data.message || 'Could not send reset code');
      }
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Could not send reset code');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell footer={<AuthBackHome />}>
      <AuthHeader
        title="Forgot password"
        subtitle="We’ll email you a 6-digit code to set a new password."
      />

      {sent ? (
        <div className="space-y-5">
          <p className="text-sm text-gray-600">
            If an account exists for <strong>{email}</strong>, a code is on its way.
            Check your inbox (and spam).
          </p>
          <Link
            to={`/reset-password?email=${encodeURIComponent(email.trim().toLowerCase())}`}
            className="block w-full text-center rounded-lg bg-orange-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-orange-700"
          >
            Enter code &amp; new password
          </Link>
          <AuthFooterLink to="/login" prompt="Remembered it?" linkText="Sign in" />
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-5">
          <AuthError message={error} />
          <AuthField
            id="email"
            label="Email"
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            autoComplete="email"
            icon="envelope"
            required
          />
          <AuthSubmitButton loading={loading} loadingText="Sending…">
            Send reset code
          </AuthSubmitButton>
          <AuthFooterLink to="/login" prompt="Remembered it?" linkText="Sign in" />
        </form>
      )}
    </AuthShell>
  );
};

export default ForgotPasswordPage;
